import React, { Component } from 'react';
import ProcessManager from '../../../Common/Managers/ProcessManager';

const BotonGuardar = (props) => {
    return (
        <div className="dropdown">
            <button className="btn btn-cta" type="submit" title="Guardar configuración"
                onClick={() => props.guardarConfiguracion(props.configuracion)}>
                Guardar
            </button>
        </div>
    );
}

export default BotonGuardar